module.exports = __webpack_public_path__ + "static/media/purple@2x.7e1de4bf.jpg";